export enum TimeSpans {
    MINUTE_TO_MILLISECOND = 60000
}
